import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../../AuthContext';

const ReportLayout: React.FC = () => {
    return (
        <AuthProvider>
            <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <Outlet />
            </div>
        </AuthProvider>
    );
};

export default ReportLayout;
